// extracted by mini-css-extract-plugin
module.exports = {"actions":"payroll-actions_actions__1uBUx"};